/* eslint react/prop-types: 0 */
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Icon, Pagination, Dropdown } from "semantic-ui-react";

export const TableComp = (props) => {
  const [ValueShowData, setValueShowData] = useState(10);
  const [ValuePage, setValuePage] = useState(1);

  const optionsShowData = [
    { key: 1, text: "10", value: 10 },
    { key: 2, text: "50", value: 50 },
    { key: 3, text: "100", value: 100 },
    { key: 4, text: "Semua", value: 100000 },
  ];
  const indication = () => {
    return (
      <p className="text-center">
        {props.data.content ? "Belum ada data" : "Loading data ..."}
      </p>
    );
  };

  const handlePagginate = (e, { activePage }) => {
    setValuePage(activePage);
    getData(ValueShowData, activePage);
  };

  const handleShowData = (e, { value }) => {
    setValueShowData(value);
    getData(value, ValuePage);
  };

  const getData = (show, page) => {
    props.getDataTable(show, page);
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      props.rowOnClick(e, row, rowIndex);
    },
  };

  return (
    <>
      <div className="card">
        <BootstrapTable
          headerClasses="table--header"
          keyField="id"
          data={props.data.content || []}
          columns={props.columns}
          bordered={false}
          noDataIndication={indication}
          hover={props.hover}
          rowEvents={props.rowOnClick && rowEvents}
          // ddefaultSortDirection="asc"
          // rowStyle={ rowStyle }
        />
      </div>
      <div className="row mt-3">
        <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
          <label className="mr-3">Tampilkan</label>
          <Dropdown
            className="w-25"
            defaultValue={ValueShowData}
            fluid
            selection
            options={optionsShowData}
            onChange={handleShowData}
          />
        </div>
        <div className="col-md-6 d-flex justify-content-md-end">
          <Pagination
            ellipsisItem={null}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
            }}
            prevItem={{ content: <Icon name="angle left" />, icon: true }}
            nextItem={{ content: <Icon name="angle right" />, icon: true }}
            defaultActivePage={ValuePage}
            boundaryRange={0}
            siblingRange={1}
            totalPages={props.data.totalPages || 0}
            onPageChange={handlePagginate}
          />
        </div>
      </div>
    </>
  );
};
